import { PrinterType, PrinterTypes } from 'src/constants/PrinterType';

export function isWifiPrinter(printerType?: PrinterType): boolean {
    return printerType === PrinterTypes.WIFI;
}
